export default __webpack_public_path__ + "eb2827c8740df61c73713ae7e1ab81a2.png";